"use strict";

import "./DropdownMenu.css";
import React from "react";
import classnames from "classnames";
import Button from "./../Button";
import Picker from "./../Picker";

class DropdownMenu extends React.Component {
	
	constructor(props) {
		super(props);
		this.initState();
	}
	
	initState() {
		this.state = {
			shown: false
		};
	}
	
	toggle() {
		this.setState({
			shown: !this.state.shown
		});
	}
	
	prepareChildren() {
		const children = this.props.children.constructor == Array ? this.props.children : [this.props.children];
		return children.map((child, i) =>
			child.type === Separator ? <Separator key={i} /> : <Item key={i} {...child.props} onFire={() => this.setState({shown: false})}/>
		);
	}
	
	renderMenu() {
		return (
			<Picker
				className="DropdownMenu"
				shown={this.state.shown}
				onWindowClick={() => this.setState({shown: false})}
			>
				<ul>
					{this.prepareChildren()}
				</ul>
			</Picker>
		);
	}
	
	render() {
		return (
			<Button
				icon="dots-vertical"
				className={this.props.className}
				onClick={() => this.toggle()}
			>
				{this.renderMenu()}
			</Button>
		);
	}
	
}

DropdownMenu.propTypes = {
	className:	React.PropTypes.string
};

class Item extends React.Component {
	
	render() {
		return (
			<li
				className={classnames("Item", {"Disabled": this.props.disabled})}
				onClick={() => {
					if (!this.props.disabled) {
						this.props.onFire();
						this.props.onClick();
					}
				}}
			>
				{this.props.children}
			</li>
		);
	}
	
}

Item.propTypes = {
	disabled: React.PropTypes.bool,
	onClick: React.PropTypes.func,
	onFire: React.PropTypes.func
};

Item.defaultProps = {
	disabled: false,
	onClick: () => {},
	onFire: () => {}
};

class Separator extends React.Component {
	
	render() {
		return (
			<li className="Separator" />
		);
	}
	
}

export {DropdownMenu as DropdownMenu};
export {Item as Item};
export {Separator as Separator};


// WEBPACK FOOTER //
// ./~/vwa/components/DropdownMenu/DropdownMenu.jsx